import { render, staticRenderFns } from "./whole.vue?vue&type=template&id=2a42c3dc&scoped=true"
import script from "./whole.vue?vue&type=script&lang=js"
export * from "./whole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42c3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a42c3dc')) {
      api.createRecord('2a42c3dc', component.options)
    } else {
      api.reload('2a42c3dc', component.options)
    }
    module.hot.accept("./whole.vue?vue&type=template&id=2a42c3dc&scoped=true", function () {
      api.rerender('2a42c3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/examine/whole.vue"
export default component.exports